import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getOnlineTraining } from "./Services/SelfLearning";
import { LoaderContext } from "../../../Services/Loader_Provider_Service/LoadingContext";
import AddCourseToWishlist from "./SelfLearningDashboard/AddCourseToWishlist/AddCourseToWishlist";
import { LazyVideo } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";

function LessonDetail() {
    let userDetails = JSON.parse(localStorage.getItem("User") || '');
    const [courses, setCourses] = useState([]);
    const { showLoading, hideLoading } = useContext(LoaderContext);
    const { CourseId } = useParams();
    const imageTigger = 1;
    useEffect(() => {
        GetOnlineTraining();
    }, [])
    async function GetOnlineTraining() {
        showLoading();
        let body = {
            "AccountId": userDetails?.OrgId,
            "LoggedInUserId": userDetails?.EmpId,
            "UserId": 0,
            "CourseId": Number(CourseId),
            "Search": "",
            "PageNumber": 1,
            "CategoryId": 0,
            "PageSize": 100,
            "NewOnly": 0,
            "BookmarkedOnly": 0,
            "FreeOnly": 0,
            "MyCourse": 0
        }
        try {
            let response = await getOnlineTraining(body);
            hideLoading();
            setCourses(response.Data.courses[0]);
        } catch (err) {
            hideLoading();
        }
    }
    return (
        <div>

            <div id="circular-menu" className="circular-menu">

                <a className="floating-btn" >
                    <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
                    <i aria-hidden="true" className="fa fa-times"></i>
                </a>

                <div className="items-wrapper">
                    <div className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </div>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </a>
                    <Link to="" className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </Link>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                    </a>
                </div>

            </div>
            {/* <!-- row --> */}

            <div className="container-fluid">

                <div className="row">
                    <div className="col-xl-8">
                        <div className="col-xl-12">
                            <div className="card position-rel">
                                <div className="card-body">
                                    <div className="course-vedio">                                       
                                        <LazyVideo className="avatar is-squared w-100" src={`${courses?.TeaserVideo}`} />
                                        <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" fill="currentColor" className="bi bi-play-circle" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                            <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                                        </svg>
                                    </div>
                                    <div className="block-header more-padding">
                                        <div className="coursedetail">
                                            <div className="des">
                                                <h4 className="block-heading">{courses?.CourseTitle}</h4>
                                                <p className="block-text">{courses?.CourseContent}</p>
                                                <div className="students pb-0 createdby">
                                                    <div className="h-avatar is-small">
                                                        <b>Created by : </b>
                                                        <img className="avatar" src="/images/avatar/6.jpg" alt="" />
                                                    </div>
                                                    <a className="link is-dark-primary">{courses?.ByName}</a>
                                                </div>
                                                <div className="info-brief">
                                                    <ul>
                                                        <li>{courses?.Modules} Modules</li>
                                                        <li>{courses?.Lessons} Lessons</li>
                                                        <li>{courses?.Quiz} Quizzes</li>
                                                    </ul>
                                                </div>
                                                <div className="showrating-course"><b>4.5</b>
                                                    <ul>
                                                        <li>
                                                            <i className="fa fa-star"></i>
                                                        </li>
                                                        <span><Link to={`/SelfLearningDashboard/CourseDetails/CourseReviews/${courses.Id}`}>(1542) Students Ratings</Link></span>
                                                    </ul>
                                                </div>
                                            </div>
                                            <Link className="add-more" to={`/SelfLearningDashboard/CourseDetails/${CourseId}`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                                    fill="currentColor" className="bi bi-arrow-left-short" viewBox="0 0
                                                  16 16"><path fillRule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.7
                                                  07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
                                                  .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"></path></svg>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <img className="avatar position-ab" src="/images/org-img//learn/coursepng.png" alt="" />
                            </div>

                        </div>
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body ">
                                    <div className="more-jobdetail p-3">
                                        <h5 className='for-course'>What you'll learn</h5>
                                        <ul className="course-role">
                                            <li><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-check2" viewBox="0 0 16 16">
                                                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                                            </svg>If you want to learn to code from scratch through building fun and useful projects, then take this course.</li>
                                            <li><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-check2" viewBox="0 0 16 16">
                                                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                                            </svg>If you want to start your own startup by building your own websites and web apps.</li>
                                            <li><svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-check2" viewBox="0 0 16 16">
                                                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                                            </svg>If you are a complete beginner then this course will be everything you need to become a Python professional</li>
                                            <li><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-check2" viewBox="0 0 16 16">
                                                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                                            </svg>If you are a complete beginner then this course will be everything you need to become a Python professional</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-4">
                        <AddCourseToWishlist courseDetails={courses} imageTigger={imageTigger} />
                    </div>
                </div>

            </div>
            <div className="modal fade" id="quizzes">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title m-auto"><img className="avatar is-squared" src="/images/org-img/learn/4.jpg" />Next.js 14 Real Estate App with Prisma , MongoDB , Clerk</h5>
                        </div>
                        <div className="modal-body">
                            <ul className="rate">
                                <li className="check"><span>1</span></li>
                                <li><span>2</span></li>
                                <li><span>3</span></li>
                                <li><span>4</span></li>
                                <li><span>5</span></li>
                                <li><span>6</span></li>
                                <li><span>7</span></li>
                                <li><span>8</span></li>
                                <li><span>9</span></li>
                                <li><span>10</span></li>
                            </ul>
                            <div className="detail">
                                <span>Choose one option</span>
                                <h3>In 2017, Sed do eiusmod tempor incididunt ut labore et dolore magna?</h3>
                                <div className="question">
                                    <strong>A.  Answer 1</strong>
                                    <input type="radio" id="a" name="fav_language" value="A" />
                                </div>
                                <div className="question selected">
                                    <strong>B.  Answer 2</strong>
                                    <input type="radio" id="b" name="fav_language" value="B" checked />
                                </div>
                                <div className="question">
                                    <strong>C.  Answer 3</strong>
                                    <input type="radio" id="c" name="fav_language" value="C" />
                                </div>
                                <div className="question">
                                    <strong>D.  Answer 4</strong>
                                    <input type="radio" id="d" name="fav_language" value="D" />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-danger" data-bs-toggle="modal" data-bs-target="#view-score" data-dismiss="modal">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="viewquizzes">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title m-auto"><img className="avatar is-squared" src="/images/org-img/learn/4.jpg" />Next.js 14 Real Estate App with Prisma , MongoDB , Clerk</h5>
                        </div>
                        <div className="modal-body">
                            <ul className="show-result">
                                <li><span>1</span><i className="fa fa-check"></i></li>
                                <li><span>2</span><i className="fa fa-check"></i></li>
                                <li><span>3</span><i className="fa fa-check"></i></li>
                                <li className="wrong"><span>4</span><i className="fa fa-times" aria-hidden="true"></i></li>
                                <li><span>5</span><i className="fa fa-check"></i></li>
                                <li><span>6</span><i className="fa fa-check"></i></li>
                                <li className="wrong"><span>7</span><i className="fa fa-times" aria-hidden="true"></i></li>
                                <li><span>8</span><i className="fa fa-check"></i></li>
                                <li><span>9</span><i className="fa fa-check"></i></li>
                                <li><span>10</span><i className="fa fa-check"></i></li>
                            </ul>
                            <div className="detail">
                                <h3>In 2017, Sed do eiusmod tempor incididunt ut labore et dolore magna?</h3>
                                <div className="question">
                                    <strong>A.  Answer 1</strong>
                                    <input type="radio" id="a" name="fav_language" value="A" />
                                </div>
                                <span>Wrong Answer</span>
                                <div className="question selected wrong">
                                    <strong>B.  Answer 2</strong>
                                    <input type="radio" id="b" name="fav_language" value="B" checked />
                                    <i className="fa fa-times" aria-hidden="true"></i>
                                </div>
                                <span>Correct Answer</span>
                                <div className="question right">
                                    <strong>C.  Answer 3</strong>
                                    <input type="radio" id="c" name="fav_language" value="C" />
                                    <i className="fa fa-check" aria-hidden="true"></i>
                                </div>
                                <div className="question">
                                    <strong>D.  Answer 4</strong>
                                    <input type="radio" id="d" name="fav_language" value="D" />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-danger" data-bs-dismiss="modal">Okay! Got it</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="view-score">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content text-center">
                        <div className="modal-header d-block text-center">
                            <h5 className="modal-title m-auto">Result Score</h5>
                            <p className="mb-0">Last updated today 09.25</p>
                        </div>
                        <div className="progress blue">
                            <span className="progress-left">
                                <span className="progress-bar"></span>
                            </span>
                            <span className="progress-right">
                                <span className="progress-bar"></span>
                            </span>
                            <div className="progress-value">90%

                            </div>
                        </div>
                        <span>Out of 100</span>
                        <strong>Very good!</strong>
                        <p>Your score is in warm up model</p>
                        <div className="modal-footer">
                            <i className="fa fa-angle-right" aria-hidden="true" data-bs-toggle="modal" data-bs-target="#viewquizzes" data-dismiss="modal"></i>
                        </div>
                        <p>View Questions</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default LessonDetail;